<template>
  <v-app>
    <pages-core-app-bar v-if="menu" />
    <pages-core-view
      :style="
        overflow ? 'overflow: auto; ' : 'overflow: hidden; height: 100vh;'
      "
      :fullscreen="fullscreen"
    />
  </v-app>
</template>

<script>
export default {
  name: "PagesIndex",
  props: {
    menu: {
      type: Boolean,
      default: true,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    overflow: {
      type: Boolean,
      default: true,
    },
    theme: {
      type: String,
      default: "dark",
    },
  },
  components: {
    PagesCoreAppBar: () => import("./components/core/AppBar"),
    PagesCoreView: () => import("./components/core/View"),
  },

  created() {
    if (this.theme === "dark") this.$vuetify.theme.dark = true;
    else this.$vuetify.theme.dark = false;
  },

  beforeDestroy() {
    this.$vuetify.theme.dark = false;
  },
};
</script>
